import {TableColumnGroups} from "../../commons/angular/models/table-column-option.model";

// columns.id isn't offered where it only toggles text inside the pinned ID cell

export const JOBS_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Service Info',
    labelPrefix: 'PLANNING_DRAFT_JOBS_VIEW_SETTINGS.',
    columnIds: {
      address: ['col-pickup-address', 'col-dropoff-address'],
      timeWindow: 'col-time-window',
      contacts: 'col-contact',
      serviceTime: 'col-service-time',
      sla: 'col-sla',
      account: 'col-account',
      vehicles: 'col-vehicles',
      accountExternalId: 'col-account-ext-id',
      labels: 'col-labels',
      tags: 'col-tags',
      skills: 'col-skills',
      packages: 'col-packages',
      leftoverReason: 'col-leftover-reason',
      recurringServiceTemplateId: 'col-recurring'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      packages: 'col-load-packages',
      value: 'col-load-value',
      pallets: 'col-load-pallets',
      spots: 'col-load-spots'
    }
  }
};

// Grouping by type hides every other column
export const JOBS_GROUPED_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Service Info',
    labelPrefix: 'PLANNING_DRAFT_JOBS_VIEW_SETTINGS.',
    columnIds: {
      account: 'col-account',
      skills: 'col-skills'
    }
  }
};

export const ROUTES_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Route Info',
    labelPrefix: 'PLANNING_DRAFT_ROUTES_VIEW_SETTINGS.',
    columnIds: {
      id: 'col-route-id',
      status: 'col-status',
      agent: 'col-agent',
      vehicle: 'col-vehicle',
      timeWindow: 'col-time-window',
      duration: 'col-duration',
      distance: 'col-distance',
      jobsCount: 'col-jobs-count',
      activitiesCount: 'col-activities-count',
      accounts: 'col-accounts',
      accountExternalId: 'col-account-ext-id',
      pickingHour: 'col-picking-hour',
      carrier: 'col-carrier',
      skills: 'col-skills',
      labels: 'col-labels',
      income: 'col-income',
      value: 'col-value'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      packages: 'col-load-packages',
      value: 'col-load-value',
      pallets: 'col-load-pallets',
      spots: 'col-load-spots'
    }
  },
  capacity: {
    title: 'Capacity Bar',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-capacity-weight',
      volume: 'col-capacity-volume',
      pallets: 'col-capacity-pallets'
    }
  }
};

export const RESOURCES_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Resources Info',
    labelPrefix: 'PLANNING_DRAFT_RESOURCES_VIEW_SETTINGS.',
    columnIds: {
      agent: 'col-agent',
      vehicle: 'col-vehicle',
      logisticVehicle: 'col-logistic-vehicle',
      timeWindow: 'col-time-window',
      carrier: 'col-carrier',
      skills: 'col-skills',
      labels: 'col-labels',
      tags: 'col-tags',
      routesCount: 'col-routes-count',
      totalDuration: 'col-total-duration'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      packages: 'col-load-packages',
      spots: 'col-load-spots',
      pallets: 'col-load-pallets',
      value: 'col-load-value'
    }
  },
  capacity: {
    title: 'Capacity Bar',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-capacity-weight',
      volume: 'col-capacity-volume',
      pallets: 'col-capacity-pallets'
    }
  }
};

// capacity is a single whole-object toggle in the drilldown, so it isn't offered
export const ROUTE_DRILLDOWN_COLUMN_GROUPS: TableColumnGroups = {
  columns: {
    title: 'Stops Info',
    labelPrefix: 'PLANNING_DRAFT_ROUTE_VIEW_SETTINGS.',
    columnIds: {
      type: 'col-type',
      account: 'col-account',
      accountExternalId: 'col-account-ext-id',
      contacts: 'col-contact',
      distance: 'col-distance',
      timeWindow: 'col-time-window',
      timeEstimations: 'col-eta',
      address: 'col-address',
      serviceTime: 'col-service-time',
      sla: 'col-sla',
      packages: 'col-load',
      barcodes: 'col-barcodes',
      labels: 'col-labels',
      vehicles: 'col-vehicles',
      recurringServiceTemplateId: 'col-recurring'
    }
  },
  load: {
    title: 'Load Metrics',
    labelPrefix: 'LOAD_SETTINGS.',
    columnIds: {
      weight: 'col-load-weight',
      volume: 'col-load-volume',
      value: 'col-load-value',
      pallets: 'col-load-pallets',
      spots: 'col-load-spots'
    }
  }
};
